import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const lastName: AnswerPathTreeNode = { path: 'lastName', nodeId: NodeIds.insuredLastName };
